/** The 409 body code for a copy refused because another copy of the same case is still running. */
export const COPY_IN_PROGRESS_CODE = 'COPY_IN_PROGRESS';

export const COPY_IN_PROGRESS_MESSAGE =
    'A copy of this case is already being made. Wait for it to finish, then try again.';

/**
 * True for the server's 409 COPY_IN_PROGRESS. It is not a failure: another copy of the case is
 * running (another tab, a teammate, or this action's first request). Show it as info.
 */
export function isCopyInProgressError(error: unknown): boolean {
    const e = error as { status?: number; details?: { code?: string; errorCode?: string } } | null | undefined;
    return e?.status === 409 && (e?.details?.code === COPY_IN_PROGRESS_CODE || e?.details?.errorCode === COPY_IN_PROGRESS_CODE);
}

/** The message to show for a COPY_IN_PROGRESS error. */
export function copyInProgressMessage(error: unknown): string {
    const e = error as { details?: { message?: string } } | null | undefined;
    return e?.details?.message || COPY_IN_PROGRESS_MESSAGE;
}
